// GENERATED by infra/scripts/write-client-config.mjs — do not edit.
// Source: OgAim-dev
import type { AwsConfig } from './config';

export const awsConfig: AwsConfig = {
  region: "us-east-1",
  userPoolId: "us-east-1_FFF4BKs9K",
  userPoolClientId: "2te3gpmp60ma5dngl2k9as289d",
  graphqlUrl: "https://y2iyda7wzvhvzpwa2auk3cu46a.appsync-api.us-east-1.amazonaws.com/graphql",
  realtimeUrl: "wss://y2iyda7wzvhvzpwa2auk3cu46a.appsync-realtime-api.us-east-1.amazonaws.com/graphql",
  uploadsUrl: "https://d3q2cog9zvgyke.cloudfront.net",
};

/** True once a real deploy has filled this in. */
export const isConfigured = awsConfig.userPoolId !== '';
